import React from "react";
import "../App.css"
import Banner from "./Banner";
import FAQ from "./Faq";
import Footer from "./Footer";
import OurTeam from "./OurTeam";
import Promise from "./Promise";

function Home(){
    return(
        <div>
            <Banner />
            <Promise />
            <OurTeam />
            <Footer />
        </div>
    )
}
export default Home